import '../scss/filters.scss';

import { createApp } from "vue";
import filterApp from './scripts/filter-app.vue';

if(document.readyState !== 'loading') {
	runOnStart();
}
else {
	document.addEventListener('DOMContentLoaded', function () {
			runOnStart()
	});
}

function runOnStart() {
	// Run your code here
	// home();
	// https://parceljs.org/languages/vue/
	// import filterApp from "./scripts/vue-app.vue";
	const app = createApp(filterApp);
	app.mount("#app");
}


